'use client';

import AscentCard from '@components/ascents/AscentCard/AscentCard';
import CardSkeleton from '@components/ascents/CardSkeleton';
import { useAscents } from '@lib/swr/hooks/ascents';
import { Alert, Button, Center, Loader, Stack } from '@mantine/core';
import { useIntersection } from '@mantine/hooks';
import { signIn, useSession } from 'next-auth/react';
import { useEffect, useRef } from 'react';

export default function AscentsFeed() {
  const { data: session, status } = useSession();

  const pageIndex = 0;
  const pageSize = 10;
  const { data, isLoading, isValidating, size, setSize } = useAscents(
    pageIndex,
    pageSize,
  );

  const containerRef = useRef<HTMLDivElement>(null);
  const { ref, entry } = useIntersection({
    root: containerRef.current,
    threshold: 1,
  });

  useEffect(() => {
    if (session && entry?.isIntersecting && !isLoading && !isValidating) {
      setSize(size + 1);
    }
  }, [entry, session, setSize, size, isLoading, isValidating]);

  return (
    <>
      <Stack>
        {data
          ? data.map((ascents) =>
              ascents.map((ascent) => (
                <AscentCard ascent={ascent} key={ascent._id} />
              )),
            )
          : [...new Array(pageSize)].map((el, i) => (
              <CardSkeleton key={`${i}`} />
            ))}
      </Stack>
      <Center my='md' w='100%' ref={ref}>
        {status !== 'loading' && !session ? (
          <Alert w='100%' title='Please sign in to see more ascents!'>
            <Button size='sm' onClick={() => signIn()}>
              Sign in
            </Button>
          </Alert>
        ) : (
          <Loader />
        )}
      </Center>
    </>
  );
}
